import React, { useEffect, useRef } from 'react'
import cx from 'classnames'
import { Dropdown } from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux'
import Proptypes from 'prop-types'
import Logo from '../logo/logo'
import styles from './nav-bar.module.css'
import ToggleButton from '../toggle-button/toggle-button'
import { history } from '../../redux/store'
import { ToggleMenu } from '../../redux/actions/navbar'
import IntelMsg from '../ItelMsg'

const Navbar = ({ setContainerMarginTop }) => {
  const toggle = useSelector((store) => store.navbar.toggleMenu)
  const dispatch = useDispatch()
  const { productName, email } = useSelector((store) => ({
    productName: store.product.productName,
    email: store.auth.userEmail,
  }))
  const firstLetterCapitalize = (s) => s && s[0].toUpperCase() + s.slice(1)

  const navBarRef = useRef()
  useEffect(() => {
    if (navBarRef.current.clientHeight)
      setContainerMarginTop(navBarRef.current.clientHeight)
  }, [navBarRef.current])
  return (
    <div ref={navBarRef} className={cx(styles.container)}>
      <div className={cx(styles.items)}>
        <div>
          <ToggleButton />
          <Logo />
        </div>
        <Dropdown
          direction="left"
          text={firstLetterCapitalize(productName)}
          icon="user"
          button
          labeled
          className="icon"
          options={options(
            email,
            () => {
              if (toggle) dispatch(ToggleMenu())
              localStorage.clear()
              history.push('/login')
            },
            () => {
              history.push('/product')
            },
          )}
        />
      </div>
    </div>
  )
}

const options = (email, onSignOutClick, onChangeProductClick) => [
  {
    key: 'user',
    text: (
      <>
        <IntelMsg id="signedInAs" /> <strong>{email}</strong>
      </>
    ),
    disabled: true,
  },
  // { key: 'profile', text: <IntelMsg id="yourProfile" /> },
  // { key: 'settings', text: <IntelMsg id="settings" /> },
  {
    key: 'changeProduct ',
    text: <IntelMsg id="changeProduct" />,
    onClick: () => {
      onChangeProductClick()
    },
  },
  {
    key: 'sign-out',
    text: <IntelMsg id="signOut" />,
    onClick: () => {
      onSignOutClick()
    },
  },
]

Navbar.propTypes = {
  setContainerMarginTop: Proptypes.func.isRequired,
}
export default Navbar
